import React, { useState } from 'react';
import { Fab, Tab, Tabs } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import AssetUploadModal from '@dyl/components/AssetUploadModal';
import { useImages } from '@dyl/systems/ImagesManager';
import { useAudios } from '@dyl/systems/AudiosAssetsManager';
import { useTitle } from '@dyl/systems/TitleManager';
import ImagesList from './ImagesList';
import AudiosList from './AudiosList';
import useStyles from './styles';
import ScreenActions from '@dyl/components/ScreenActions';

export default function MediaList() {
    useTitle('Images & Audio');
    const classes = useStyles();

    const [tab, setTab] = useState('images');
    const [isUploaderOpen, setUploaderOpen] = useState(false);

    const { refreshImages: requestImages } = useImages();
    const { refreshAudios: requestAudios } = useAudios('ITEM');
    const { refreshAudios: requestMotivationalAudios } = useAudios('MOTIVATIONAL');

    return (
        <>
            <Tabs
                value={tab}
                onChange={(event, value) => setTab(value)}
                indicatorColor='primary'
                className={classes.tabGroup}
            >
                <Tab value='images' label='Images' />
                <Tab value='item audios' label='Item Audios' />
                <Tab value='motivational audios' label='Motivational Audios' />
            </Tabs>

            {tab === 'images' && <ImagesList />}
            {tab === 'item audios' && <AudiosList type="ITEM" />}
            {tab === 'motivational audios' && <AudiosList type="MOTIVATIONAL" />}

            <ScreenActions>
                <Fab
                    color='primary'
                    variant='extended'
                    size='large'
                    onClick={() => setUploaderOpen(true)}
                >
                    <AddIcon />&nbsp;Upload
                </Fab>
            </ScreenActions>

            <AssetUploadModal
                type={tab}
                open={isUploaderOpen}
                onClose={({ didUpload }) => {
                    setUploaderOpen(false);

                    if (didUpload) {
                        if (tab === 'images') {
                            requestImages();
                        } else if (tab === 'item audios') {
                            requestAudios();
                        } else if (tab === 'motivational audios') {
                            requestMotivationalAudios();
                        }
                    }
                }}
            />
        </>
    );
}